import {
  ICurrencyResp,
  IPaymentGatewayReqUIFormSchema,
  PaymentMethodTypeEnum,
} from '@monetize/types/app';
import {
  Control,
  FieldErrors,
  useFieldArray,
  UseFormWatch,
} from 'react-hook-form';
import { MText } from '../../../../../components/Monetize';
import { PaymentMethodTypeEnumDisplay } from '../../../../../constants/paymentMethods';
import { PaymentMethodAmountSection } from './PaymentMethodAmountSection';

const SECTION_CONFIG = [
  {
    type: PaymentMethodTypeEnum.CREDIT_CARD,
    enabledField: 'creditCardEnabled' as const,
    fixedCurrency: false,
  },
  {
    type: PaymentMethodTypeEnum.DIRECT_DEBIT,
    enabledField: 'directDebitEnabled' as const,
    fixedCurrency: false,
  },
  {
    type: PaymentMethodTypeEnum.US_BANK_TRANSFER,
    enabledField: 'usBankTransferEnabled' as const,
    fixedCurrency: true,
  },
];

interface StripeFormAmountConfigurationProps {
  control: Control<IPaymentGatewayReqUIFormSchema>;
  errors: FieldErrors<IPaymentGatewayReqUIFormSchema>;
  watch: UseFormWatch<IPaymentGatewayReqUIFormSchema>;
  currencies: (ICurrencyResp & { description: string; searchTerm: string })[];
}

export const StripeFormAmountConfiguration = ({
  control,
  errors,
  watch,
  currencies,
}: StripeFormAmountConfigurationProps) => {
  const { fields } = useFieldArray({
    control,
    name: 'paymentConfiguration.configurations',
  });

  return (
    <>
      <MText fontSize="lg" fontWeight="bold" mt={2}>
        Payment Amount Configuration
      </MText>
      <MText fontSize="sm">
        Define allowable amounts for automatic payments.
      </MText>

      {SECTION_CONFIG.map((section) => {
        const configIndex = fields.findIndex(
          ({ type }) => type === section.type,
        );
        if (configIndex === -1) {
          return null;
        }

        const isEnabled = !!watch(section.enabledField);

        return (
          <PaymentMethodAmountSection
            key={section.type}
            control={control}
            errors={errors}
            configIndex={configIndex}
            label={PaymentMethodTypeEnumDisplay[section.type]}
            isEnabled={isEnabled}
            currencies={currencies}
            fixedCurrency={section.fixedCurrency}
          />
        );
      })}
    </>
  );
};
